export const LANG_STORAGE_KEY = "lifechart_lang";

export const SUPPORTED_LANGUAGES = ["az", "ru", "en"];

export const DEFAULT_LANGUAGE = "az";

/**
 * API dil ötürülməsi rejimi:
 * - "header" → Accept-Language header
 * - "query"  → ?lang=az query parametri
 * - "both"   → hər ikisi
 *
 * .env: REACT_APP_API_LANG_MODE=header|query|both
 */
export const API_LANG_MODE =
  process.env.REACT_APP_API_LANG_MODE || "both";

export const DATE_LOCALE_BY_LANG = {
  az: "az-Latn-AZ",
  ru: "ru-RU",
  en: "en-GB",
};
